import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Divider as BaseDivider, Icon } from '@treezor/design-system';
import { twMerge } from 'tailwind-merge';

const gridStyle = css`
  display: grid;
  gap: ${({ theme }) => theme.spacing[6]};
  width: 100%;
`;

export const TwoColumns = styled.div`
  grid-template-columns: 1fr 1fr;
  ${gridStyle}
`;

export const CustomColumns = styled.div<{ columns: number[] }>`
  grid-template-columns: ${({ columns }) => columns.map((col: number) => `${col}fr `)};
  ${gridStyle}
`;

const Divider = styled(BaseDivider)`
  margin: ${({ theme }) => theme.spacing[3]} 0;
`;

interface IContentLayout {
  title: string;
  children: ReactNode;
  hasDivider?: boolean;
  contentClassName?: string;
}

interface ISubSection {
  title?: string;
  children: ReactNode;
}

interface ISectionInformation {
  title: string;
  content: string;
}

export function ContentLayout({ title, children, hasDivider = true, contentClassName }: IContentLayout) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex gap-7 items-start w-full">
        <div className="text-secondary typo-h5-bold" style={{ width: 200 }}>
          {title}
        </div>
        <div className={twMerge('flex flex-col gap-6 w-full', contentClassName)}>{children}</div>
      </div>
      {hasDivider && <Divider />}
    </div>
  );
}

export function Section({ children, title }: ISubSection) {
  return (
    <div className="flex flex-col gap-6">
      {title && <h6 className="typo-h6-bold text-secondary">{title}</h6>}
      <div className="flex flex-col gap-6 pb-[4px]">{children}</div>
    </div>
  );
}

export function SectionInformation({ title, content }: ISectionInformation) {
  return (
    <div className="flex gap-7 p-5 rounded-200 bg-tag-blue">
      <Icon name="info" className="text-icon-info" size="m" />
      <div>
        <p className="typo-body-semibold-paragraphLarge"> {title}</p>
        <p className="typo-body-regular-small"> {content}</p>
      </div>
    </div>
  );
}
